import React, { useEffect, useState } from 'react';
import OverNLBADetailLayout from '../components/OverNLBADetailLayout';
import { contentAPI } from '../services/api';
import banner from '../assets/bg-mba-gamesindustrie.jpg';
import './OverNLBA.css';

const REVIEW_SECTIONS = [
  { key: 'hbo', title: 'HBO' },
  { key: 'masterclasses', title: 'Masterclasses' },
  { key: 'masteropleidingen', title: 'Masteropleidingen' }
];

const normalizeReviewCategory = (value) => {
  if (value === 'hbo' || value === 'bachelor') return 'hbo';
  if (value === 'masterclasses' || value === 'masterclass') return 'masterclasses';
  if (value === 'masteropleidingen' || value === 'masteropleiding') return 'masteropleidingen';
  if (value === 'hbo_masterclasses' || value === 'hbo-masterclasses') return 'hbo';
  return 'hbo';
};

const OverNLBAReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const groupedReviews = REVIEW_SECTIONS.map((section) => ({
    ...section,
    items: reviews.filter((review) => normalizeReviewCategory(review.category) === section.key)
  })).filter((section) => section.items.length > 0);

  useEffect(() => {
    let isMounted = true;
    const loadReviews = async () => {
      setLoading(true);
      try {
        const data = await contentAPI.getPublicReviews();
        if (!isMounted) return;
        setReviews(data.reviews || []);
        setError('');
      } catch (err) {
        if (!isMounted) return;
        setError('Reviews konden niet worden geladen.');
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    loadReviews();
    return () => { isMounted = false; };
  }, []);

  return (
    <OverNLBADetailLayout
      title="Reviews"
      subtitle="Ervaringen en resultaten van studenten, alumni en professionals."
      heroImage={banner}
      heroAlt="Reviews NLBA"
    >
            <h2>Reviews</h2>
            {loading && <p>Laden...</p>}
            {error && <p>{error}</p>}
            {!loading && !error && reviews.length === 0 && (
              <p>Er zijn momenteel nog geen reviews gepubliceerd.</p>
            )}
            {!loading && !error && reviews.length > 0 && (
              <div className="over-nlba-grouped-sections">
                <div className="over-nlba-group-chips" aria-label="Review categorieen">
                  {groupedReviews.map((section) => (
                    <a key={section.key} href={`#reviews-${section.key}`} className="over-nlba-group-chip">
                      <span>{section.title}</span>
                      <strong>{section.items.length}</strong>
                    </a>
                  ))}
                </div>

                {groupedReviews.map((section) => (
                  <section key={section.key} id={`reviews-${section.key}`} className="over-nlba-group-section over-nlba-group-panel">
                    <div className="over-nlba-group-head">
                      <h3>{section.title}</h3>
                      <span className="over-nlba-group-count">{section.items.length} reviews</span>
                    </div>
                    <div className="over-nlba-review-grid">
                      {section.items.map((review) => (
                        <article key={review.id} className="over-nlba-review-card">
                          {review.hasPhoto && (
                            <img
                              src={contentAPI.reviewPhotoUrl(review.id)}
                              alt={review.name}
                              className="over-nlba-review-photo"
                              loading="lazy"
                            />
                          )}
                          <h3>{review.name}</h3>
                          <p className="over-nlba-muted">{review.role || '-'}</p>
                          <p className="over-nlba-review-quote">"{review.quote}"</p>
                        </article>
                      ))}
                    </div>
                  </section>
                ))}
              </div>
            )}
    </OverNLBADetailLayout>
  );
};

export default OverNLBAReviews;
